exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".image-spacer-div {\r\n    width: 60px;\r\n}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// C:/dev/emaray.io/src/app/cv/cv.component.css
// module id = ../../../../../src/app/cv/cv.component.css
// module chunks = main